import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/fields/RadioGroup/index.jsx";
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import FormHint from '../../structure/FormHint';
import Label from '../../structure/Label';
import FormRow from '../../structure/FormRow';
import { inputDefaultProps, inputPropTypes } from '../../../commonProps';
function RadioGroupComponent(props) {
  var _this = this;
  var id = props.id,
    name = props.name,
    inputRef = props.inputRef,
    choices = props.choices,
    currentChoice = props.currentChoice,
    _onChange = props.onChange,
    labelClass = props.labelClass,
    inputClass = props.inputClass,
    wrapperClass = props.wrapperClass,
    errorClass = props.errorClass,
    rowClass = props.rowClass,
    errors = props.errors,
    disabled = props.disabled,
    readOnly = props.readOnly,
    warning = props.warning,
    info = props.info;
  var hasErrors = errors && Object.hasOwnProperty.call(errors, name);
  var errorMessage = hasErrors ? errors[name].message : null;
  var wrapperClassName = hasErrors ? "".concat(wrapperClass, " ").concat(errorClass) : wrapperClass;
  return /*#__PURE__*/React.createElement(FormRow, {
    className: rowClass,
    hasErrors: hasErrors,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  }, Object.keys(choices).map(function (key, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: wrapperClassName,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement("input", {
      ref: inputRef,
      type: "radio",
      name: name,
      id: "".concat(id, "-").concat(index),
      className: inputClass,
      checked: key === currentChoice,
      value: key,
      onChange: function onChange(event) {
        return _onChange(event.target.value);
      },
      disabled: disabled,
      readOnly: readOnly,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 25
      }
    }), /*#__PURE__*/React.createElement(Label, {
      id: "".concat(id, "-").concat(index),
      className: labelClass,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 25
      }
    }, choices[key]));
  }), /*#__PURE__*/React.createElement(FormHint, {
    error: errorMessage,
    warning: warning,
    info: info,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  }));
}
export default function RadioGroup(props) {
  var _this2 = this;
  return /*#__PURE__*/React.createElement(Controller, Object.assign({
    defaultValue: ""
  }, props, {
    render: function render(_ref) {
      var onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        value = _ref.value;
      return /*#__PURE__*/React.createElement(RadioGroupComponent, Object.assign({}, props, {
        onChange: onChange,
        onBlur: onBlur,
        currentChoice: value || '',
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70,
          columnNumber: 13
        }
      }));
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }));
}
RadioGroup.propTypes = _objectSpread(_objectSpread({}, inputPropTypes), {}, {
  wrapperClass: PropTypes.string
});
RadioGroup.defaultProps = _objectSpread(_objectSpread({}, inputDefaultProps), {}, {
  labelClass: 'form-label form-label--radio',
  inputClass: 'form-element form-element--radio',
  wrapperClass: null
});